export const onGetFinalPages = (chosenPage: number, maxPages: number, pages: number[]): number[] => {
    if (chosenPage > pages.length - maxPages + 1) {
        return pages.slice(pages[pages.length - maxPages], pages[pages.length])
    }
    return [pages[pages.length - 1]]
}
